"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = exports.IdentityDocumentType = exports.CustomerType = exports.Country = exports.RiskProfileLevel = void 0;
var RiskProfileLevel;
(function (RiskProfileLevel) {
    RiskProfileLevel["LEVEL_100"] = "LEVEL_100";
    RiskProfileLevel["LEVEL_200"] = "LEVEL_200";
    RiskProfileLevel["LEVEL_300"] = "LEVEL_300";
    RiskProfileLevel["LEVEL_400"] = "LEVEL_400";
    RiskProfileLevel["LEVEL_500"] = "LEVEL_500";
})(RiskProfileLevel || (exports.RiskProfileLevel = RiskProfileLevel = {}));
var Country;
(function (Country) {
    Country["PE"] = "PE";
})(Country || (exports.Country = Country = {}));
var CustomerType;
(function (CustomerType) {
    CustomerType["BUSINESS"] = "BUSINESS";
    CustomerType["INDIVIDUAL"] = "INDIVIDUAL";
})(CustomerType || (exports.CustomerType = CustomerType = {}));
var IdentityDocumentType;
(function (IdentityDocumentType) {
    IdentityDocumentType["DNI"] = "DNI";
    IdentityDocumentType["PASAPORTE"] = "PASAPORTE";
    IdentityDocumentType["DCE"] = "DCE";
    IdentityDocumentType["RUC"] = "RUC";
})(IdentityDocumentType || (exports.IdentityDocumentType = IdentityDocumentType = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
})(Currency || (exports.Currency = Currency = {}));
//# sourceMappingURL=Customer.js.map